import { render, staticRenderFns } from "./modulos.vue?vue&type=template&id=6e6107d4&scoped=true"
import script from "./modulos.vue?vue&type=script&lang=js"
export * from "./modulos.vue?vue&type=script&lang=js"
import style1 from "./modulos.vue?vue&type=style&index=1&id=6e6107d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6107d4",
  null
  
)

export default component.exports